<template>
    <div style="display: flex;width: 100%;justify-content: center;margin-top: 10px" v-if="isShow">
        <div class="store-body-container">
            <!--左侧图片-->
            <div class="picture">
                <img :src="storeOption.leftImg">
            </div>
            <!--右侧商标-->
            <div class="right">
                <div class="brand">
                    <a  v-for="(shop,index) in shops" :key="index"  :href="shop.url" target="_blank">
                        <img :src="shop.imgSrc">
                    </a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        components: {
        
        },
        data() {
            return {
                
            }
        },
        computed:{
            isShow : function(){
                return this.$store.state.malMainPageConfig.isShowSelf
            },
            storeOption:function(){
                return this.$store.state.malMainPageConfig.storeBody.storeOption
            },
            shops : function(){
                return this.$store.state.malMainPageConfig.storeBody.shops
            }
        }
    }
</script>

<style scoped lang="scss">
  .store-body-container{
    display: flex;
    width: 1200px;
    justify-content: center;
    align-items: center;
    background: #ffffff70;
  }
  .store-body-container .picture img{
    width: 100px;
    height: 150px;
    z-index: 1;
  }
  .store-body-container .right{
    display: flex;
    justify-content: center;
    align-content: center;
    width: 1075px;
    height: 150px;
    background: #ffffff;
    margin-left: 25px;
  }
  .right .brand{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      overflow: hidden;
  }
    .right div>a>img{
        margin-left: 11px;
        width: 202px;
        height: 128px;
    }



</style>
